import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import {Router, ActivatedRoute} from '@angular/router'
import {AngularFirestore} from 'angularfire2/firestore'
import {FolderService} from '../folder.service'
import {StorageService} from '../../core/upload/upload.service'
import {LoaderService} from '../../ui-shared/loader/loader.service'

@Component({
  selector: 'app-folder-view',
  templateUrl: './folder-view.component.html',
  styleUrls: ['./folder-view.component.scss'],
})
export class FolderViewComponent implements OnInit {
  view: string = 'list'
  // showSuggestedFilters: string = 'show'
  cansubmit: boolean = true
  @ViewChild('gallery') gallery
  search: string = ''
  isChrome: boolean = false
  newProjectId: string

  constructor(
    public folder: FolderService,
    public storageService: StorageService,
    public loader: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    public firestore: AngularFirestore
  ) {}

  ngOnInit() {
    this.newProjectId = this.firestore.collection('projects').ref.doc().id
    this.isChrome = navigator.userAgent.indexOf('Chrome') != -1
    window.onresize = () => this.resize()
    this.resize()
    this.route.queryParams.subscribe(params => {
      this.search = params['search'] || ''
      // Delete "?search=" from URL if no search
      if (params['search'] == '') {
        let _params = {...params}
        delete _params['search']
        this.router.navigate([], {
          queryParams: _params,
          replaceUrl: true,
          relativeTo: this.route,
        })
      }
    })
  }

  resize() {
    let window_width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) &&
      window_width <= 768
    ) {
      this.view = 'mobile'
    } else {
      this.view = localStorage.getItem('preferred_view') || 'grid'
      // this.showSuggestedFilters =
      localStorage.getItem('show_suggested_filters') || 'show'
    }
  }

  switchView(view) {
    this.view = view
    localStorage.setItem('preferred_view', this.view)
  }

  // toggleSuggestedFilters() {
  //   this.showSuggestedFilters =
  //     this.showSuggestedFilters == 'show' ? 'hide' : 'show'
  //   localStorage.setItem('show_suggested_filters', this.showSuggestedFilters)
  // }

  deleteFolder() {
    const keyword = 'YES'
    const skip_verification = false

    let verification = skip_verification
      ? ''
      : window.prompt(`
Warning: You are about to delete an entire folder and it's content.
THIS ACTION CAN NOT BE UNDONE.

We just want to make sure you don't delete files by mistake.

Please type "${keyword}" to delete "${this.folder.current.name}" and all its content?`)

    if (
      skip_verification ||
      (verification && verification.toLowerCase() === keyword.toLowerCase())
    ) {
      let openNext = this.folder.current.parents.slice(-1)[0]
      this.loader.start('Deleting folder...')
      this.folder.delete(this.folder.current.id).then(completed => {
        this.router.navigate(['/folder/', openNext.id])
        this.loader.stop()
      })
    } else {
      new Notification(
        `Deletion cancelled. You didn't type the verification word.`
      )
    }
  }

  filter(text, event) {
    if (event && event.shiftKey) {
      if (this.search.includes(text)) {
        this.search = this.search
          .split(' & ')
          .filter(n => n !== text)
          .join(' & ')
      } else {
        this.search += ' & ' + text
      }
    } else if (text) {
      this.search = text == this.search ? '' : text
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        search: this.search,
      },
      queryParamsHandling: 'merge',
    })
    this.folder.filter(this.search)
  }

  download() {
    this.storageService.downloadFiles(
      this.folder.current.files_array,
      this.folder.current.name
    )
  }

  isInteger(val): boolean {
    return val == parseInt(val, 10)
  }

  onUpload(data) {
    let _update = {
      files: data,
      versions: this.folder.current.versions || {},
      messages: this.folder.current.messages || {},
    }

    for (let i in data) {
      _update.versions[i] = _update.versions[i] || []
      _update.versions[i].push(data[i])

      let updateMessageId = this.folder.createPushId()
      _update.messages[i] = _update.messages[i] || {}
      _update.messages[i][updateMessageId] = {
        id: updateMessageId,
        type: 'update',
        path: data[i].path,
        date: data[i].updated,
        user: {
          username: data[i].uploaded_by.username || data[i].uploaded_by.name,
          uid: data[i].uploaded_by.uid || data[i].uploaded_by.id,
        },
      }
    }

    this.folder
      .update(this.folder.current.id + '/versions', _update.versions)
      .then(() => {
        this.folder
          .update(this.folder.current.id + '/messages', _update.messages)
          .then(() => {
            this.folder
              .update(this.folder.current.id + '/files', _update.files)
              .then(() => {
                this.router.navigate(['/folder/', this.folder.current.id])
                this.loader.stop()
              })
          })
      })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-view/folder-view.component.ts